import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchStatsByType } from 'Store/stats/actions';
import { initializeList, updateStatsListSearch } from 'Store/lists/actions';
import * as reducers from 'Store/reducers';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

import Error from 'Containers/Error';
import Loading from 'Components/Loading';
import { getDateString, daysUntilDate } from '../../utilities';
import Table from 'Components/Table';
import { ROUTES } from '../../settings/route-strings';

class AdminStatsPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      requestedStats: false,
    };
  }

  componentDidMount() {
    this.fetchStats();
  }

  fetchStats() {
    if (!this.state.requestedStats) {
      this.setState({ requestedStats: true }, () => {
        this.props.initializeList('educators_stats', 'educators_stats');
        this.props.fetchStatsByType('educators');
      });
    }
  }

  render() {
    const { activeUser, pageError, list } = this.props;
    if (pageError) return <Error type="apiLoadError" code="500" />;
    if (!activeUser || !list) return <Loading />;

    const { data } = list;
    const Header = ({ column: { id } }) => (
      <ConnectedFormattedMessage id={`users_list.column_labels.${id}`} />
    );

    const columns = [
      { Header: 'ID', accessor: 'user_id', width: 80 },
      { Header: 'Name', accessor: 'given_name' },
      { Header: 'School Name', accessor: 'school_name' },
      { Header, accessor: 'email' },
      {
        Header,
        accessor: 'last_login_at',
        Cell: ({ value }) =>
          value &&
          getDateString(new Date(value), {
            timeZone: 'America/New_York',
            day: 'numeric',
            month: 'numeric',
            year: '2-digit',
            hour: 'numeric',
          }),
      },
      { Header: 'Login Count', accessor: 'login_count', width: 70 },
      {
        Header: 'License Expiry Date',
        accessor: 'licenses[0].end_time',
        width: 120,
        Cell: ({ value }) => value && daysUntilDate(new Date(value)),
      },
    ];

    const dataList = Object.keys(data).map(key => data[key]);

    return (
      <div>
        <Table columns={columns} data={dataList} />
      </div>
    );
  }
}

AdminStatsPage.propTypes = {
  activeUser: PropTypes.object,
  pageError: PropTypes.object,
  list: PropTypes.object,
  initializeList: PropTypes.func.isRequired,
  fetchStatsByType: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  const type = 'educators';
  return {
    activeUser: reducers.getActiveUser(state),
    pageError: reducers.getPageError(state, ROUTES.ADMIN_V2_STATS_EDUCATORS),
    isFetchingStats: reducers.isFetchingStats(state, 'statsByType'),
    list: reducers.getStatsListByType(state, type),
  };
};

export default connect(mapStateToProps, {
  fetchStatsByType,
  initializeList,
  updateStatsListSearch,
})(AdminStatsPage);
